import { render, staticRenderFns } from "./TariffChange.vue?vue&type=template&id=3a060710"
import script from "./TariffChange.vue?vue&type=script&lang=js"
export * from "./TariffChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports